/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPharmacyStockIndent } from 'app/shared/model/pharmacy-stock-indent.model';
import { PharmacyIndentStatus } from 'app/shared/model/enumerations/pharmacy-indent-status.model';
import { PharmacyProductType } from 'app/shared/model/enumerations/pharmacy-product-type.model';

export interface IPharmacyStockIndentItem {
  id?: string;
  indentStatus?: keyof typeof PharmacyIndentStatus | null;
  indentedQty?: number | null;
  fulfilledQty?: number | null;
  packs?: number | null;
  productType?: keyof typeof PharmacyProductType | null;
  productId?: string;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  indent?: IPharmacyStockIndent;
}

export const defaultValue: Readonly<IPharmacyStockIndentItem> = {
  active: false,
};
